import React from "react";

export default function ReplacementIcon(props) {
  return (
    <svg width={27} height={27} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={27} height={27} transform="matrix(-1 0 0 1 27 0)" fill="white" />
      <path
        d="M13.5 6.1875C19.71 6.1875 24.75 8.7075 24.75 11.8125C24.75 14.3325 21.4425 16.4587 16.875 17.1787V20.8125L12.375 16.3125L16.875 11.8125V14.8837C20.4187 14.2537 22.5 12.7462 22.5 11.8125C22.5 10.62 19.08 8.4375 13.5 8.4375C7.92 8.4375 4.5 10.62 4.5 11.8125C4.5 12.6337 6.1425 13.9387 9 14.6587V16.965C5.02875 16.0987 2.25 14.1187 2.25 11.8125C2.25 8.7075 7.29 6.1875 13.5 6.1875Z"
        fill="#444444"
      />
    </svg>
  );
}
